import { lazy } from "react"

export const DispatcherOrderById = lazy(() => import("./DispatcherOrderById"))
export const DispatcherTimeCoordinateById = lazy(() => import("./DispatcherTimeCoordinateById"))
